import React from 'react';
import Title from 'components/TitleWithIcon';
import Slide from '@material-ui/core/Slide';
import Dialog from '@material-ui/core/Dialog';
// import CitizenIdentityDataResumen from './resumen';
import {useStyles} from 'pages/solicitudesExtranjero/solicitudesNuevas/SolicitudesEmpadronamiento/styles';
import {useStylesResume} from './styles';
import {Today, LocationOn, AccountCircle, Person, Wc,  } from '@material-ui/icons';
import { AppBar, Toolbar, IconButton, Typography, Grid, Divider, Button, ListItemText, ListItemIcon, Chip, ListItem} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import CitizenIdentityDataResumen from './resumen';
import {functions} from 'constants/index';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function CitizenIdentityData(props) {
    const classes = useStyles();
    const classesResume = useStylesResume();
    // console.log('props.citizenIdentityDataGeneral: ', props.citizenIdentityDataGeneral)
    return (
        <div>
            <Dialog  
                open={props.showCitizenIdentityData}
                maxWidth={"lg"}
                fullWidth
                TransitionComponent={Transition}
                keepMounted
                onClose={props.closeShowCitizenIdentityData}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                disableBackdropClick={true}
                disableEscapeKeyDown={true}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <IconButton edge="start" color="inherit" onClick={props.closeShowCitizenIdentityData} aria-label="close">
                            <CloseIcon />
                        </IconButton>
                        <Typography variant="h6" className={classes.title}>
                           DATOS DEL CIUDADANO
                        </Typography>
                        <Button autoFocus color="inherit" onClick={props.closeShowCitizenIdentityData}>
                            Cerrar
                        </Button>
                    </Toolbar>
                </AppBar>
                <Title title="Datos del ciudadano" icon={"/menu/Document.png"}/>
         
                <Grid item xs={12}>
                    <div className={classes.centerTitle}><Divider /> <strong>FOTO, FIRMA, HUELLA</strong> <Divider /></div>
                </Grid >
                <Grid item xs={12}>
                    <CitizenIdentityDataResumen citizenIdentityData={props.citizenIdentityData}/>
                </Grid > 
                <Grid container className={classesResume.marginBotton}>
                    <Grid item xs={12}>
                        <div className={classes.centerTitle}><Divider /> <strong>DATOS GENERALES DEL CIUDADANO</strong> <Divider /></div>
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Código Estado Padrón: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.padronData?.codStatus} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Nombre Estado Padrón: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.padronData?.nombreStatus} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Nombre completo: " />
                            <ListItemIcon className={classesResume.colorIcon}><AccountCircle/></ListItemIcon>
                        </ListItem>
                    </Grid > 
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}  label={props.citizenIdentityDataGeneral.fullName} />                                
                    </Grid >
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText}  primary="Sexo: " />
                            <ListItemIcon className={classesResume.colorIcon} ><Wc/></ListItemIcon>
                        </ListItem>
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={props.citizenIdentityDataGeneral.gender}  /> 
                    </Grid >    
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Fecha de Nacimiento: " />
                            <ListItemIcon className={classesResume.colorIcon}><Today/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={functions.dateFormatGeneral(props.citizenIdentityDataGeneral.dateOfBirth)}  />                                
                    </Grid >   
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Lugar de Nacimiento: " />
                            <ListItemIcon className={classesResume.colorIcon}><LocationOn/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip} label={props.citizenIdentityDataGeneral.birthPlace} />                                
                    </Grid >  
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem} >
                            <ListItemText className={classesResume.rootListItemText} primary="Nombre del Padre: " />
                            <ListItemIcon className={classesResume.colorIcon}><Person/></ListItemIcon>
                        </ListItem>                
                    </Grid >
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}
                            label={props.citizenIdentityDataGeneral.fatherFullName}
                        />                                
                    </Grid >  
                    <Grid item xs={3}>
                        <ListItem className={classesResume.rootListItem}>
                            <ListItemText className={classesResume.rootListItemText} primary="Nombre de la Madre: " />
                            <ListItemIcon className={classesResume.colorIcon}><Person/></ListItemIcon>
                        </ListItem>                
                    </Grid >                
                    <Grid item xs={3}>
                        <Chip variant="outlined" className={classesResume.colorChip}
                            label={props.citizenIdentityDataGeneral.motherFullName}
                        />                                
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}